/* Svensk katalog for locale-invoice-live.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'actionApproval.approve': 'Godkänn',
  'actionApproval.approveAction': 'Godkänn: {action}',
  'live.reviewTitle': 'Granska fakturan',
  'live.reviewInvoice': 'Kontrollera fakturan nedan innan du godkänner.',
  'live.deliveryLabel': 'Skicka som',
  'live.approveSend': 'Godkänn och skicka',
  'live.approveIssue': 'Godkänn och skapa',
  'actionApproval.label.send_offer': 'Skicka offert',
  'actionApproval.label.send_credit_note': 'Skicka kreditfaktura',
  'actionApproval.label.send_reminder': 'Skicka betalningspåminnelse utan avgift',
  'actionApproval.label.post_purchase': 'Registrera och bokför inköp',
  'actionApproval.label.reverse_purchase': 'Återför inköp',
  'actionApproval.label.post_manual_voucher': 'Bokför verifikation',
  'actionApproval.label.reverse_voucher': 'Återför verifikation',
  'actionApproval.label.approve_payroll_run': 'Godkänn och bokför lönekörning',
  'actionApproval.label.reverse_payroll_run': 'Återför lönekörning',
  'actionApproval.label.record_payroll_submission': 'Bekräfta att a-melding har skickats in utanför Plumme',
  'actionApproval.label.close_accounting_year': 'Godkänn och stäng räkenskapsåret',
  'actionApproval.label.reopen_accounting_year': 'Öppna räkenskapsåret igen',
  'actionApproval.label.delete_invoice_drafts': 'Ta bort fakturautkast',
  'actionApproval.label.delete_purchase_draft': 'Ta bort inköpsutkast',
  'actionApproval.label.delete_payroll_draft': 'Ta bort löneutkast',
  'actionApproval.label.delete_project': 'Ta bort projekt',
  'actionApproval.label.invite_business_member': 'Bjud in användare till företaget',
  'actionApproval.label.remove_business_member': 'Ta bort användarens åtkomst till företaget',
  'actionApproval.label.cancel_business_invite': 'Dra tillbaka inbjudan',
  'live.reading': 'Läser formuläret och väljer nästa steg …',
  'live.open_editor': 'Öppnar fakturaredigeraren …',
  'live.set_layout': 'Byter vy …',
  'live.set_customer': 'Väljer kund …',
  'live.set_field': 'Fyller i fält …',
  'live.set_line': 'Fyller i fakturarad …',
  'live.remove_line': 'Tar bort fakturarad …',
  'live.open_customer_form': 'Förbereder ny kund …',
  'live.open_product_form': 'Förbereder ny produkt …',
  'live.review': 'Öppnar förhandsgranskning …',
  'live.request_save': 'Förbereder för godkännande …',
  'live.finish': 'Kontrollerar resultatet …',
  'live.ask_user': 'Behöver ett förtydligande …',
  'live.approval': 'Väntar på att du kontrollerar och sparar formuläret.',
  'live.customerApproval': 'Kontrollera den nya kunden i formuläret. När du sparar fortsätter jag med fakturan.',
  'live.productApproval': 'Kontrollera den nya produkten, priset och momsen i formuläret. När du sparar fortsätter jag med fakturan.',
  'live.customerSaved': 'Kunden har sparats. Fortsätter med fakturan.',
  'live.productSaved': 'Produkten har sparats. Fortsätter med fakturan.',
  'live.cancelled': 'Skapandet har avbrutits. Arbetet med fakturan är pausat.',
  'live.notApplied': 'Fältet uppdaterades inte som förväntat. Jag har stannat så att du kan kontrollera formuläret.',
  'live.limit': 'Jag har nått gränsen för antal steg. Kontrollera formuläret och beskriv vad som återstår.',
  'live.done.open_editor': 'Fakturaredigeraren är öppnad.',
  'live.done.set_layout': 'Vyn har ändrats.',
  'live.done.set_customer': 'Kunden är vald.',
  'live.done.set_field': 'Fältet är ifyllt och kontrollerat.',
  'live.done.set_line': 'Fakturaraden är ifylld och kontrollerad.',
  'live.done.remove_line': 'Fakturaraden har tagits bort.',
  'control.productRequired': 'Produkten finns inte i det aktiva produktregistret.',
  'control.intro': 'Berätta vilken faktura du vill skapa. Jag fyller i formuläret och kan skapa kunder och produkter som behövs. Be uttryckligen om att skapa och skicka när jag ska slutföra fakturan.',
  'live.create_customer': 'Sparar kunden …',
  'live.create_product': 'Sparar produkten …',
  'live.issue_invoice': 'Skapar fakturan …',
  'live.send_invoice': 'Skapar och skickar fakturan …',
  'live.finished': 'Ifyllningen är klar. Ändringarna är kontrollerade i fakturaformuläret.',
  'live.clarification': 'Beskriv vad du vill göra härnäst med fakturan.',
  'live.invoiceIssued': 'Fakturan har skapats. Den har inte skickats.',
  'live.invoiceSent': 'Fakturan har skickats via e-post.',
  'live.emailRequired': 'För att skicka behöver jag kundens e-postadress och avsändarens e-post i företagsinställningarna. Ange mottagaradressen tillsammans med en ny begäran om att skicka.',
  'live.authorizationRequired': 'Skriv uttryckligen vad du vill skapa eller skicka.',
  'live.deliveryUncertain': 'Utskick har redan försökts. Kontrollera utskicksstatus i fakturalistan innan ett nytt försök, så att kunden inte får fakturan dubbelt.',
  'live.deliveryNotSent': 'Fakturan har skapats, men utskicket bekräftades inte. Kontrollera utskicksstatus i fakturalistan.',
  'live.ambiguousRecord': 'Flera kunder eller produkter har samma namn. Välj rätt post först.',
  'live.actionBusy': 'En sparning eller ett utskick pågår redan.',
  'appControl.changed': 'Sidan eller företaget har ändrats. Kontrollera sidan och be mig fortsätta.',
  'appControl.unsupported': 'Den här kontrollen kräver att du använder den direkt på sidan.',
  'appControl.authorization': 'Berätta vilken åtgärd du vill att jag ska utföra.',
  'appControl.manual': 'Slutför det här steget direkt på sidan, så kan jag fortsätta.',
  'appControl.option': 'Valet är inte tillgängligt i det här fältet.',
  'appControl.repeated': 'Åtgärden har redan försökts. Kontrollera resultatet på sidan innan du fortsätter.',
  'actionApproval.title': 'Godkänn åtgärd',
  'actionApproval.body': 'Kontrollera åtgärden och uppgifterna nedan. Godkännandet gäller bara det här steget.',
  'actionApproval.confirm': 'Godkänn och utför',
  'actionApproval.proposal': 'Föreslagen åtgärd',
  'actionApproval.context': 'Uppgifter som åtgärden gäller',
  'actionApproval.cancel': 'Avbryt',
  'actionApproval.mcp': 'Åtgärd från ansluten AI',
  'actionApproval.failed': 'Åtgärden kunde inte utföras. Hämta ett nytt förslag och försök igen.',
  'actionApproval.loading': 'Hämtar åtgärden ...',
  'actionApproval.done': 'Åtgärden är utförd.',
  'actionApproval.business': 'Företag',
  'actionApproval.writeScope': 'AI:n kan föreslå skrivåtgärder. Varje åtgärd måste godkännas av dig i Plumme innan den utförs.',
  'actionApproval.label.create_invoice_draft': 'Skapa fakturautkast',
  'actionApproval.label.register_invoice_payment': 'Registrera fakturabetalning',
  'actionApproval.label.save_draft': 'Spara utkast',
  'actionApproval.label.send_invoice': 'Skicka faktura',
  'actionApproval.label.issue_invoice': 'Utfärda faktura',
  'actionApproval.label.create_customer': 'Skapa kund',
  'actionApproval.label.create_product': 'Skapa produkt',
  'actionApproval.label.invoice': 'Faktura',
  'actionApproval.label.invoiceId': 'Faktura-ID',
  'actionApproval.label.customer': 'Kund',
  'actionApproval.label.customerName': 'Kundnamn',
  'actionApproval.label.currency': 'Valuta',
  'actionApproval.label.amount': 'Belopp',
  'actionApproval.label.date': 'Datum',
  'actionApproval.label.dueDate': 'Förfallodatum',
  'actionApproval.label.lines': 'Rader',
  'actionApproval.label.quantity': 'Antal',
  'actionApproval.label.unitPrice': 'Enhetspris',
  'actionApproval.label.vatRate': 'Momssats',
  'actionApproval.label.description': 'Beskrivning',
  'actionApproval.label.business': 'Företag',
  'actionApproval.label.expires': 'Giltig till',
  'actionApproval.label.recipientEmail': 'Mottagare',
  'actionApproval.label.fields': 'Fält',
  'actionApproval.label.label': 'Namn',
  'actionApproval.label.value': 'Värde',
  'actionApproval.label.text': 'Uppgifter på sidan',
  'actionApproval.label.action': 'Åtgärd',
  'actionApproval.label.click': 'Tryck',
  'actionApproval.label.fill': 'Fyll i',
  'actionApproval.label.select': 'Välj',
  'actionApproval.label.check': 'Ändra val',
  'actionApproval.label.checked': 'Vald',
  'actionApproval.label.post': 'Bokför',
  'actionApproval.label.approve': 'Godkänn lönekörning',
  'actionApproval.label.close_year': 'Godkänn och stäng räkenskapsåret',
  'actionApproval.label.reopen_year': 'Öppna räkenskapsåret igen',
  'actionApproval.label.manage_members': 'Ändra åtkomst',
  'actionApproval.label.delete': 'Ta bort eller återför',
  'actionApproval.label.submit': 'Skicka in',
  'actionApproval.label.expense': 'Inköp',
  'actionApproval.label.supplier': 'Leverantör',
  'actionApproval.label.year': 'År',
  'actionApproval.label.records': 'Poster',
});
